import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { StringParam, useQueryParams } from 'use-query-params';
function QueryClaim() {
    const location = useLocation();
    const [query, setQuery] = useQueryParams({
        type: StringParam,
    })

    useEffect(() => {
        if (location.pathname === '/noi-tru') {
            setQuery({ type: 'noi_tru' });
        } else if (location.pathname === '/ngoai-tru') {
            setQuery({ type: 'ngoai_tru' });
        }
    }, [location.pathname, setQuery]);

    return null;
}

export default QueryClaim
